import gql from 'graphql-tag';

export const investigationMetricsInvestigatorConnection = gql`query InvestigationMetricsInvestigatorConnection($filters: [InvestigationMetricsFilter], $orderBy: InvestigationMetricsOrderBy, $first: Int, $last: Int, $before: ID, $after: ID, $sortOrder: SortOrder) {
investigationMetricsInvestigatorConnection(first: $first, last: $last, before: $before, after: $after, filters: $filters, orderBy: $orderBy, sortOrder: $sortOrder) {
    pageInfo
    {
      limit
      offset
    }
    totalCount
    edges
    {
      cursor
      node
      {
        id
        firstName
        middleName
        lastName
        data
      }
    }
  }
}`
